module.exports = __webpack_public_path__ + "img/project3_5.png.8e8578d6.webp";